/**
 * 个人中心积分任务: 点击游戏内容链接时, 记录标识到cookie, 供个人中心积分任务使用
 */

import Cookies from 'js-cookie'
import Bus from './eventBus.js'
import util from '../lib/util.js'

let task_date_cookie_sign = 'me-center-task-date'
let task_count_cookie_sign = 'me-center-task-count'

let new_task_date_cookie_sign = '9-task-done'
let new_task_count_cookie_sign = '9-task-count'

function init() {
  $('body').on('click', 'a[href][data-xlog]', addTaskCount)
}

function addTaskCount() {
  let nowDate = util.dateFormat(new Date(), 'yyyy-MM-dd')
  let taskDate = Cookies.get(task_date_cookie_sign)
  let taskCount = Cookies.get(task_count_cookie_sign) || 0

  if (nowDate !== taskDate) {
    Cookies.set(task_date_cookie_sign, nowDate, {expires: 1, path: '/', domain: 'browser.qq.com'});
    Cookies.set(task_count_cookie_sign, 1, {expires: 1, path: '/', domain: 'browser.qq.com'});

    Cookies.set(new_task_date_cookie_sign, nowDate, {expires: 1, path: '/', domain: 'browser.qq.com'});
    Cookies.set(new_task_count_cookie_sign, 1, {expires: 1, path: '/', domain: 'browser.qq.com'});
  }
  else {
    taskCount = parseInt(taskCount) + 1
    Cookies.set(task_count_cookie_sign, taskCount, {expires: 1, path: '/', domain: 'browser.qq.com'});

    Cookies.set(new_task_date_cookie_sign, nowDate, {expires: 1, path: '/', domain: 'browser.qq.com'});
    Cookies.set(new_task_count_cookie_sign, taskCount, {expires: 1, path: '/', domain: 'browser.qq.com'});
  }
  Bus.$emit('addTaskCount')
}

export default {
  init: init,
  addTaskCount: addTaskCount
}